import apiServiceCall from "../services/ApiServiceCall";

export const getFrequentQuestions = () => {
  return apiServiceCall().get('/vui/frontend/faqs').then(({ data }) => data);
}

